/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import { client, withUnwrap } from '../.kubb/client'
import type { MeAcceptInviteOptions, MeAcceptInviteResponses } from '../models/MeAcceptInvite'
import {
  meAcceptInviteResponseSchema,
  meAcceptInviteErrorSchema,
  meAcceptInviteBodySchema,
} from '../schemas/meAcceptInviteSchema'

/**
 * @summary Accept an invitation to join an organization, and switch into it. The role granted may be reduced —
 * or `None` — when the company has no free seat; the join still happens. Because the org and roles
 * live in the access token, this reissues the token pair and resets the refresh cookie, returning the
 * same shape as auth/switch so the client needs no follow-up call.
 * {@link /api/v4/me/invites/accept}
 */
export function meAcceptInvite<ThrowOnError extends boolean = true>(
  options: Options<MeAcceptInviteOptions, ThrowOnError>
): Unwrappable<RequestResult<MeAcceptInviteResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/api/v4/me/invites/accept',
      security: [{ type: 'http', scheme: 'bearer' }],
      validator: {
        request: meAcceptInviteBodySchema,
        response: meAcceptInviteResponseSchema,
        error: meAcceptInviteErrorSchema,
      },
      contentType: { request: 'application/json-patch+json' },
      ...config,
    }) as Promise<RequestResult<MeAcceptInviteResponses, ThrowOnError>>
  )
}
